/**
 * @generated SignedSource<<b9edcb2cf41b0811bae1ca18ef2aaff3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CaseLinkModalDeleteMutation$variables = {
  id: string;
};
export type CaseLinkModalDeleteMutation$data = {
  readonly softDelete: {
    readonly success: boolean | null;
  } | null;
};
export type CaseLinkModalDeleteMutation = {
  response: CaseLinkModalDeleteMutation$data;
  variables: CaseLinkModalDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SoftDelete",
    "kind": "LinkedField",
    "name": "softDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CaseLinkModalDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CaseLinkModalDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "149afd7a209bcf1352d8193114b08ba1",
    "id": null,
    "metadata": {},
    "name": "CaseLinkModalDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CaseLinkModalDeleteMutation(\n  $id: ID!\n) {\n  softDelete(id: $id) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "43a76579a8b3437c20b218669143e46e";

export default node;
